import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsString, IsOptional, IsEnum, IsUUID } from 'class-validator'
import { ActivityVisibility } from '../../../enums'

export class UpdateLearningPathDto {
  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  @IsString()
  title?: string

  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  @IsString()
  description?: string

  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  @IsUUID()
  subjectExternalId?: string

  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  @IsUUID()
  classLevelExternalId?: string

  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  @IsUUID()
  establishmentId?: string

  @ApiPropertyOptional({ enum: ActivityVisibility })
  @IsOptional()
  @IsEnum(ActivityVisibility)
  visibility?: ActivityVisibility
}
